import React from 'react'
import ImgBack from '../../images/back--24.webp'
import './postCardBack.scss'

const PostCardBack = () => {
  return <img className="PostCardBack" src={ImgBack} alt="Gavula Family Highlights from 2024" />
}

export default PostCardBack
